import { gql } from '@apollo/client';

export const FIND_STRATEGY_FACILITY_BY_STRATEGY_ID = gql`
  query FindStrategyFacilityByStrategy($uuid: ID!) {
    findStrategyFacilityByStrategy(uuid: $uuid) {
      summary
      uuid
    }
  }  
`;

export const FIND_SECTION_OWNER_BY_STRATEGY = gql`
  query FindSectionOwnerByStrategy($strategyType: Facility, $uuid: ID!){
    findSectionOwnerByStrategy(strategyType: $strategyType, uuid: $uuid) {
      email
      sectionOwnerfirstName
      sectionOwnerlastName
      sectionRequired
      uuid
    }
  }
`;

export const FIND_FACILITIES_BY_STRATEGY = gql`
  query FindAllFacilitiesByStrategyFacility($uuid: ID!) {
    findAllFacilitiesByStrategyFacility(uuid: $uuid) {
      adequate
      available
      contactFirstName
      contactLastName
      cost
      email
      name
      rampUpTime
      uuid
    }
  }
`;

